import { FC } from "react"
import { TextAlignProps } from "../../contactAndSafetyInfo/types";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";

const AuthMaunfacturerSubHeader: FC = (): JSX.Element => {

  return (
    <div className="row align-items-center mt-3">
      <div className="col-12 col-md-3 text-left">
        <div className="row">
          <div className="col">
          </div>
        </div>
      </div>

      <div className="col-12 col-md-3 text-center">
        <div className="col-12 col-md-3 text-left">
        </div>
      </div>

      <div className="col-12 col-md-6">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} />
      </div>
    </div>
  );
};

export default AuthMaunfacturerSubHeader;
